export default {"src":"/_next/static/media/left-arrow.adf03ed3.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};